'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotScatterIcon = function PlotScatterIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M0 8c0 1.5 1.188 2.688 2.688 2.688C4.126 10.688 5.313 9.5 5.313 8S4.125 5.312 2.688 5.312A2.668 2.668 0 0 0 0 8zm10.688 8c0 1.5 1.188 2.688 2.625 2.688 1.5 0 2.688-1.188 2.688-2.688s-1.188-2.688-2.688-2.688c-1.438 0-2.625 1.188-2.625 2.688zM16 9.313c0 1.5 1.188 2.688 2.688 2.688 1.438 0 2.625-1.188 2.625-2.688a2.64 2.64 0 0 0-2.625-2.625c-1.5 0-2.688 1.188-2.688 2.625zM5.313 24c0 1.5 1.188 2.688 2.688 2.688S10.689 25.5 10.689 24c0-1.5-1.188-2.688-2.688-2.688S5.313 22.5 5.313 24zm16-4c0 1.5 1.188 2.688 2.688 2.688S26.689 21.5 26.689 20c0-1.5-1.188-2.688-2.688-2.688S21.313 18.5 21.313 20zm5.375-8c0 1.5 1.188 2.688 2.625 2.688 1.5 0 2.688-1.188 2.688-2.688s-1.188-2.688-2.688-2.688c-1.438 0-2.625 1.188-2.625 2.688z' })
    );
};

exports.default = PlotScatterIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/PlotScatterIcon.js
// module id = 682
// module chunks = 0